module.exports = {
    "baseUrl": "https://api-v4.staging.iris-health.com",
    "systemName": "System dev",
    "checkinUrl": "https://checkin.staging.iris-health.com",
    "appointmentPortal": "https://a.trillium.health",
    "companyTitle": "Appointment reminder | Iris Health",
    "metaTitle": "Appointment reminder",
    "favicon": "%PUBLIC_URL%/iris/iconWhite.ico",
    "companyName": "Iris Health",
    "copyRight": "Iris Health is a trademark of its respective owner.",
    "companyKey": "iris",
    "cdnUrl": "https://cdn.staging.iris-health.com"
}